const style1 = {
    st: {
        textAlign: 'right'
    }
}

export default style1;